// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___R7oS","delete":"styles_delete__2dK0w","update":"styles_update__3zmee","add":"styles_add__3Avx1"};